interface SelectBtnSurveyProps extends React.ComponentProps<'div'> {
  submit: () => void
}

export default function SelectButtonSurvey ({ submit, ...rest }: SelectBtnSurveyProps) {

  return(
    <div {...rest}>
      
    </div>
  )
}